module.exports = __webpack_public_path__ + "48b27ffafa3c546a2c0f8b64cf3e1b19.png";